<section class="no-auth-page">
  <header>
    <h3>{{ 'shared.completeProfile.welcome' | translate }}</h3>
    <h4>{{ 'shared.completeProfile.subtitle' | translate }}</h4>
  </header>

  <form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
    <div class="ht-form-item">
      <div class="ht-form-item-title">
        {{ 'shared.completeProfile.email' | translate }}
      </div>
      <div class="ht-form-item-control">
        <ht-input
          [label]="'shared.completeProfile.email' | translate"
          type="email"
          formControlName="email"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    <div class="ht-form-item">
      <div class="ht-form-item-title">
        {{ 'shared.completeProfile.username' | translate }}
      </div>
      <div class="ht-form-item-control">
        <ht-input
          [label]="'shared.completeProfile.username' | translate"
          type="text"
          formControlName="username"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    <div class="ht-form-item">
      <div class="ht-form-item-title">
        {{ 'shared.completeProfile.firstName' | translate }}
      </div>
      <div class="ht-form-item-control">
        <ht-input
          [label]="'shared.completeProfile.firstName' | translate"
          type="text"
          formControlName="first_name"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    <div class="ht-form-item">
      <div class="ht-form-item-title">
        {{ 'shared.completeProfile.lastName' | translate }}
      </div>
      <div class="ht-form-item-control">
        <ht-input
          [label]="'shared.completeProfile.lastName' | translate"
          type="text"
          formControlName="last_name"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    @if (form.errors?.serverError) {
      <div class="ht-form-row">
        <div class="error-alert">
          <i class="fa-solid fa-circle-xmark"></i>
          <span>{{ form.errors?.serverError }}</span>
        </div>
      </div>
    }

    <div class="ht-form-actions">
      <button
        ht-button-primary
        type="submit"
        size="large"
        [fullWidth]="true"
        [isLoading]="isLoading"
      >
        {{ 'shared.completeProfile.continue' | translate }}
      </button>
    </div>
  </form>
</section>
